import { render, staticRenderFns } from "./xunjiang-project-list.vue?vue&type=template&id=610542c2&scoped=true"
import script from "./xunjiang-project-list.vue?vue&type=script&lang=js"
export * from "./xunjiang-project-list.vue?vue&type=script&lang=js"
import style0 from "./xunjiang-project-list.vue?vue&type=style&index=0&id=610542c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610542c2",
  null
  
)

export default component.exports